import React from "react";
import { Text, Column } from "@amzn/meridian";
import "./InspectionVerifySummaryFooter.scss";

interface InspectionVerifySummaryFooterProps {
    allVerified: boolean;
    /**
     * True when a non-compliant checkpoint is still unresolved (not fixed now/later
     * and not overridden to compliant). Separate from `allVerified` because the two
     * can disagree: e.g. a non-compliant manual checkpoint doesn't require
     * verification, so `allVerified` can be true while this is still true.
     */
    hasUnresolvedNonCompliance: boolean;
}

/** Verification rollup footer on the OBSERVATION card: amber when pending, green when all verified. */
const InspectionVerifySummaryFooter: React.FC<InspectionVerifySummaryFooterProps> = ({
    allVerified,
    hasUnresolvedNonCompliance,
}) => {
    if (allVerified && !hasUnresolvedNonCompliance) {
        return (
            <div className="inspection-verify-summary-footer inspection-verify-summary-footer--verified">
                <Column spacing="100" spacingInset="400">
                    <Text type="h100" color="success">
                        All checkpoints verified
                    </Text>
                    <Text type="b200" color="primary">
                        You have reviewed and verified every checkpoint. This inspection is ready
                        to submit to AUSTIN.
                    </Text>
                </Column>
            </div>
        );
    }

    if (allVerified && hasUnresolvedNonCompliance) {
        return (
            <div className="inspection-verify-summary-footer inspection-verify-summary-footer--pending">
                <Column spacing="100" spacingInset="400">
                    <Text type="h100" color="primary">
                        Action required
                    </Text>
                    <Text type="b200" color="primary">
                        Resolve each non-compliant checkpoint to unlock AUSTIN submission.
                    </Text>
                </Column>
            </div>
        );
    }

    return (
        <div className="inspection-verify-summary-footer inspection-verify-summary-footer--pending">
            <Column spacing="100" spacingInset="400">
                <Text type="h100" color="primary">
                    Verification required
                </Text>
                <Text type="b200" color="primary">
                    Resolve all findings and verify each checkpoint to unlock AUSTIN submission.
                </Text>
            </Column>
        </div>
    );
};

export default InspectionVerifySummaryFooter;
